module.exports = __webpack_public_path__ + "static/media/Fantasy_9.df64aac1.jpg";